export default "/images/fb2c339eafb88b828b5d4be11531f6ab.avif";